module.exports = __webpack_public_path__ + "img/check.5b492c92.svg";